import React from "react";
import moment from 'moment';
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Form,
  FormGroup,
  Label,
  Input
} from "reactstrap";
import Joi from "joi-browser";
import {AgentService } from "../services";
import httpClient from "../http-client/client";
import { ToastContainer, toast, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";

class UpdateAgentForm extends React.Component {
  constructor(props) {
    super(props);
    this.agentService = new AgentService();
  }

  state = {
    agent: {  //agent
      subscriptionTypeName:"", //role
      businessName: "",//name
      subscriptionBalance: "",
      subscriptionExpiry:"",
      proprietorName:"",
      cityName:"",
      status : "",//status
      updateDate: "",//createDate
      registrationDate:"",
      agentId: "",
      remarks:"" 
    },
    subscriptionTypes: [],//operators
    status: [],
    errors: {}
  };

  schema = Joi.object().keys({
    agentId: Joi.number(),
    cityName: Joi.any(),
    businessName: Joi.any(),
    proprietorName: Joi.any(),
    subscriptionTypeName: Joi.any(),
    subscriptionBalance:Joi.number(),
    status:Joi.number()
      .required()
      .error(errors =>{
        return {
          message: "Select Role"
        };
      }),
      remarks: Joi.string()
      .required()
      .error(errors => {
        return {
          message: "remarks is required."
        };
      }),
    updateDate: Joi.any(),
    registrationDate: Joi.any(),
    subscriptionExpiry:Joi.any(),
  });

  componentDidMount() {
    //this.getCities();
    this.getSubscriptionTypes();
    this.getStatus();
    this.getUser();
  }

  async getUser() {
    try {
      let {agentId} = this.props;
      console.log("my agent id",agentId);
      let { data } = await httpClient.get(`/agent/${agentId}`);
      console.log("agent data",data);
      let agent = data["response"][0][0];
      
      let info = {
        agentId: agentId,
        businessName: agent["business_name"],
        proprietorName: agent["proprietor_name"],
        cityName:agent["city_name"],
        subscriptionTypeName:agent["subscription_type_id"],
        subscriptionBalance:agent["subscription_balance"],
        subscriptionExpiry:agent["subscription_expiry"],
        status:agent["agent_status_id"],
        updateDate:agent["update_date"],
        registrationDate:agent["registeration_date"],
        remarks:agent["remarks"]
      };
      this.setState({agent: info });
    } catch (error) {
      let agent = {
      subscriptionTypeName:"", 
      businessName: "",
      subscriptionBalance: "",
      subscriptionExpiry:"",
      proprietorName:"",
      cityName:"",
      status : "",
      updateDate: "",
      registrationDate:"",
      remarks:"" , 
      agentId: ""
      };
      this.setState({agent:agent});
    }    
  }
 
  async getSubscriptionTypes() {
    try {
      let { data } = await httpClient.get("/subscriptions/types");
      console.log("MY city",data);
      this.setState({subscriptionTypes: data["response"] });
    } catch (error) {}
  }
  
  async getStatus(){
    try {
      let { data } = await httpClient.get("/agent/status");
      this.setState({ status: data["response"] });
    } catch (error) {
      this.setState({ status: [] });
    }
  }


  reset = () => {
    let agent = {
      subscriptionTypeName:"", //role
      businessName: "",//name
      subscriptionBalance: "",
      subscriptionExpiry:"",
      proprietorName:"",
      cityName:"",
      //agentStatus : "",//status
      updateDate: "",//createDate
      registrationDate:"",
      remarks:"" ,     
      status: ""
    };

    let errors = {};
    this.setState({ agent, errors });
  };

  // sign up validation
  validation() {
    let { error } = Joi.validate(this.state.agent, this.schema, {
      abortEarly: false
    });

    // No error found
    if (!error) return null;

    let errors = {};
    error.details.map(err => (errors[err.path[0]] = err["message"]));

    return errors;
  }

  // handle change
  handleChange = event => {
    let value = event.target.value;
    let agent = { ...this.state.agent };
    agent[event.target.name] = value;
    this.setState({ agent });
  };

  // on submit
  handleSubmit = async event => {
    event.preventDefault();
    // validation
    let errors = this.validation();

    if (errors) {
      console.log(errors);

      this.setState({ errors });
      return;
    } else {
      this.setState({ errors: {} });
    }

    let agent = this.state.agent;

    try {
  console.log("Update request Send;");
  const agentData={
   agentId : agent.agentId,
   status : agent.status,
   remarks : agent.remarks
 }
 console.log("API DATA",agentData);
      var { status, data } =await httpClient.put("/agent",agentData); 
      console.log(data);
      if (status === 200) {
        // show verification modal
        toast.success("دی گئی معلومات تبدیل کر دی گئی ہیں", {
          position: toast.POSITION.BOTTOM_RIGHT,
          transition: Slide
        });
        this.props.toggle();
        this.props.getUsers();
        
       // window.location.reload();
      }
      //window.location.reload();
    } catch (error) {
      // error occur

      console.log("ERORS",error);
      
      toast.error("Oops something went wrong!!!", {
        position: toast.POSITION.BOTTOM_RIGHT,
        transition: Slide
      });
     // window.location.reload();
     }
  };
  
  render() {
    let {subscriptionTypes,agent,status, errors } = this.state;
    console.log(agent);

    const subscriptionList = subscriptionTypes.map(p => (
      <option key={p["subscription_type_id"]} value={p["subscription_type_id"]}>
        {p["subscription_type_name"].toUpperCase()}
      </option>
    ));
    
    const statusList = status.map(s => (
      <option key={s["agent_status_id"]} value={s["agent_status_id"]}>
        {s["agent_status_name"].toUpperCase()}
      </option>
    ));
    return (
      <div>
        <Modal isOpen={this.props.modal} toggle={this.props.toggle} size={"lg"}>
          <ModalHeader
            className="bg-info text-light"
            toggle={this.props.toggle}
          >
            Update Agent
          </ModalHeader>
          <ModalBody>
            <Form className="row">
              <FormGroup className="col-6">
                <Label for="status">Agent Status</Label>
                <Input
                  type="select"
                  name="status"
                  value={agent.status}
                  id="status"
                  invalid={Boolean(errors["status"])}
                  onChange={this.handleChange}
                  
                >
                  <option value="">Select Status</option>
                  {statusList}
                </Input>
                
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="updatedDate">updateDate</Label>
                <Input
                  type="text"
                  name="updateDate"
                  id="updateDate"
                  placeholder="update Date"
                  value={
                    moment(agent["updateDate"]).format('DD-MM-YYYY')
                  }
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="subscriptionTypeName">subscription Name</Label>
                <Input
                  type="select"
                  name="subscriptionTypeName"
                  value={agent.subscriptionTypeName}
                  id="subscriptionTypeName"
                  disabled
              >
                  <option value="">Select Type</option>
                  {subscriptionList}
                  
                </Input>
                
              </FormGroup>
              
              <FormGroup className="col-6">
                <Label for="businessName">businessName</Label>
                <Input
                  type="text"
                  name="businessName"
                  id="businessName"
                  placeholder="businessName"
                  value={agent["businessName"]}
                
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="proprietorName">proprietorName</Label>
                <Input
                  type="text"
                  name="proprietorName"
                  id="proprietorName"
                  placeholder="proprietorName"
                  value={agent["proprietorName"]}
                 
                 disabled
                />
              </FormGroup>
              
              <FormGroup className="col-6">
                <Label for="cityId">city Name</Label>
                <Input
                  type="text"
                  name="cityName"
                  id="cityName"
                  value={agent["cityName"]}
                  placeholder="cityName"
                  
                  
                   disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="subscription Balance">subscription Balance</Label>
                <Input
                  type="text"
                  name="subscriptionBalance"
                  id="subscriptionBalance"
                  value={agent["subscriptionBalance"]}
                  placeholder="subscriptionBalance"
                  
                 disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="subscriptionExpiry">subscription Expiry</Label>
                <Input
                  type="text"
                  name="subscriptionExpiry"
                  id="subscriptionExpiry"
                  value={
                    moment(agent["subscriptionExpiry"]).format('DD-MM-YYYY')
                  }
                  placeholder="subscriptionExpiry"
                
                   disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="registrationDate">registration Date</Label>
                <Input
                  type="text"
                  name="registrationDate"
                  id="registrationDate"
                  
                  value={
                    moment(agent["registrationDate"]).format('DD-MM-YYYY')                }
                  placeholder="registrationDate"
                  disabled
                />
              </FormGroup>
              <FormGroup className="col-6">
                <Label for="remarks">Remarks</Label>
                <Input
                  type="text"
                  name="remarks"
                  id="remarks"
                  value={agent.remarks}
                  placeholder="remarks"
                  invalid={Boolean(errors["remarks"])}
                  onChange={this.handleChange}
                  // disabled
                />
              </FormGroup>
            </Form>
          </ModalBody>
          <ModalFooter>
            <Button color="info" onClick={this.handleSubmit}>
            محفوظ کریں
            </Button>{" "}
            <Button color="danger" onClick={this.props.toggle}>
            منسوخ کریں
            </Button>
          </ModalFooter>
        </Modal>

        {/* toast notifiction */}
        <ToastContainer />
      </div>
    );
  }
}

export default UpdateAgentForm;